import React from 'react';
import "../styles/Eula.css";

const Eula = () => {
  return (
    <div className="eula">
      {/* Breadcrumb Navigation */}
      <nav className="breadcrumb">
        <a href="/">Home</a> &raquo; <span>End User License Agreement</span>
      </nav>

      <h1>End User License Agreement (EULA)</h1>
      <p><strong>Last updated:</strong> January 25, 2025</p>

      <section>
        <h2>1. Company Information</h2>
        <p>
          The application <strong>Dialecto</strong> is licensed to you ("End User") by:
        </p>
        <p>
          <strong>Patryk Kotłowski JDG</strong><br />
          Registered office: Otomino, Poland<br />
          📧 Email: <a href="mailto:support@dialectoapp.com">support@dialectoapp.com</a>
        </p>
        <p>
          Hereinafter referred to as the "Licensor" or "Dialecto."
        </p>
      </section>

      <section>
        <h2>2. Acceptance of Agreement</h2>
        <p>
          By downloading or installing the Dialecto application ("Licensed Application") from Apple's App Store or Google Play, and any updates thereto, you agree to be bound by this EULA.
        </p>
        <p>
          Apple Inc. and Google LLC are not parties to this Agreement and bear no responsibility for the Licensed Application or its content. All responsibility lies with Patryk Kotłowski JDG.
        </p>
      </section>

      <section>
        <h2>3. Scope of License</h2>
        <p>
          You are granted a non-exclusive, non-transferable, revocable license to install and use the Licensed Application on your personal devices running <strong>iOS 15 or later</strong> or <strong>Android 8.0 or later</strong>.
        </p>
        <p>
          <strong>You may not:</strong>
        </p>
        <ul>
          <li>copy, rent, lease, lend, sell, redistribute, or sublicense the app;</li>
          <li>modify, decompile, disassemble, reverse-engineer, or attempt to derive the source code;</li>
          <li>use the app for any unlawful purpose.</li>
        </ul>
        <p>
          You may make one backup copy solely for personal use.
        </p>
        <p>
          Breaching these terms may result in termination of your license and possible legal action.
        </p>
        <p>
          Dialecto reserves the right to update or amend this Agreement at any time, with the latest version published at <a href="https://dialectoapp.com/eula">https://dialectoapp.com/eula</a>.
        </p>
      </section>

      <section>
        <h2>4. Technical Support</h2>
        <p>
          All maintenance and support are provided solely by Patryk Kotłowski JDG. Apple and Google have no obligation to provide any support or maintenance.
        </p>
        <p>
          📧 Contact: <a href="mailto:support@dialectoapp.com">support@dialectoapp.com</a>
        </p>
      </section>

      <section>
        <h2>5. Technical Requirements</h2>
        <p>
          You are responsible for ensuring that your device meets the technical requirements for proper operation:
        </p>
        <ul>
          <li>iOS 15 or later for Apple devices</li>
          <li>Android 8.0 or later for Android devices</li>
        </ul>
        <p>
          Dialecto may update system requirements or discontinue support for older operating systems at any time.
        </p>
      </section>

      <section>
        <h2>6. Data Processing and Privacy</h2>
        <p>
          Dialecto processes user data in accordance with the EU General Data Protection Regulation (GDPR) and its Privacy Policy available at <a href="https://dialectoapp.com/privacy">https://dialectoapp.com/privacy</a>.
        </p>
        <p>
          Technical and usage data (device type, OS version, preferred language, session data) may be collected to:
        </p>
        <ul>
          <li>improve app functionality and performance,</li>
          <li>enhance user experience,</li>
          <li>ensure security and detect technical issues.</li>
        </ul>
        <p>
          <strong>You have the right to:</strong>
        </p>
        <ul>
          <li>access your personal data,</li>
          <li>correct inaccurate data,</li>
          <li>restrict processing,</li>
          <li>request deletion of your personal data at any time.</li>
        </ul>
      </section>

      <section>
        <h2>7. User-Generated Content</h2>
        <p>
          The app allows users to submit or upload text, audio, and other materials ("Content").
        </p>
        <p>
          <strong>You agree not to submit content that:</strong>
        </p>
        <ul>
          <li>is illegal, offensive, or discriminatory,</li>
          <li>infringes intellectual-property or privacy rights,</li>
          <li>includes spam, advertising, or harmful material.</li>
        </ul>
        <p>
          Violating these rules may result in suspension or termination of your access.
        </p>
      </section>

      <section>
        <h2>8. License to User Content</h2>
        <p>
          You retain ownership of your Content. By submitting it, you grant Patryk Kotłowski JDG a non-exclusive, royalty-free, perpetual license to use, store, reproduce, and display your Content only as necessary for:
        </p>
        <ul>
          <li>operating the app,</li>
          <li>improving AI models and learning features,</li>
          <li>enhancing user experience.</li>
        </ul>
        <p>
          <strong>Dialecto will not use your Content for external commercial purposes without your consent.</strong>
        </p>
      </section>

      <section>
        <h2>9. Liability</h2>
        <p>
          Dialecto is liable only for damages caused by willful misconduct or gross negligence.
        </p>
        <p>
          Dialecto is not liable for data loss or damages resulting from improper use of the app.
        </p>
        <p>
          Nothing in this Agreement limits liability for death, personal injury, or fraud resulting from negligence.
        </p>
      </section>

      <section>
        <h2>10. Warranty and Claims</h2>
        <p>
          The app is free from malware at the time of download.
        </p>
        <p>
          No warranty applies to misuse, unauthorized modification, or use with incompatible devices.
        </p>
        <p>
          Defects may be reported within 90 days of discovery to <a href="mailto:support@dialectoapp.com">support@dialectoapp.com</a>.
        </p>
        <p>
          Dialecto may repair, replace, or refund the app via the relevant store operator.
        </p>
        <p>
          Refund requests must be submitted directly through Apple or Google.
        </p>
        <p>
          Patryk Kotłowski JDG, not Apple or Google, is responsible for addressing claims relating to the Licensed Application, including product-liability, compliance, and consumer-protection claims.
        </p>
      </section>

      <section>
        <h2>11. Legal Compliance</h2>
        <p>
          You confirm that you are not located in a country subject to EU or U.S. sanctions and that you are not listed as a prohibited or restricted party under applicable law.
        </p>
      </section>

      <section>
        <h2>12. Termination</h2>
        <p>
          This license remains in effect until terminated by you or by Dialecto. It terminates automatically without notice if you fail to comply with this Agreement. Upon termination, you must stop using and delete all copies of the app.
        </p>
      </section>

      <section>
        <h2>13. Intellectual Property</h2>
        <p>
          All intellectual-property rights in the Dialecto application remain the exclusive property of Patryk Kotłowski JDG. In the event of a third-party claim of intellectual-property infringement, Dialecto is solely responsible for handling, defending, and settling such claims.
        </p>
        <p>
          Apple Inc. and Google LLC (and their subsidiaries) are third-party beneficiaries of this License Agreement and may enforce its terms.
        </p>
      </section>

      <section>
        <h2>14. Governing Law and Dispute Resolution</h2>
        <p>
          This Agreement is governed by the laws of the Republic of Poland, excluding its conflict-of-law principles.
        </p>
        <p>
          Any disputes shall be resolved by the competent court in Poland having jurisdiction over the Licensor's registered office.
        </p>
      </section>

      <section>
        <h2>15. Final Provisions</h2>
        <p>
          If any provision of this Agreement is deemed invalid, the remaining provisions remain in full force and effect.
        </p>
        <p>
          Any amendments or modifications must be made in writing or electronically (e.g., publication of a new version online).
        </p>
        <p>
          In case of discrepancies between the Polish and English versions, the Polish version shall prevail.
        </p>
      </section>

      <section className="contact-info">
        <h2>📩 Contact</h2>
        <p>
          <strong>Patryk Kotłowski JDG</strong><br />
          Otomino, Poland<br />
          Email: <a href="mailto:support@dialectoapp.com">support@dialectoapp.com</a><br />
          Website: <a href="https://dialectoapp.com">https://dialectoapp.com</a>
        </p>
      </section>
    </div>
  );
};

export default Eula;
